exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-a569c64a]{background:#000;opacity:.7}.overlay-enter[data-v-a569c64a],.overlay-leave-to[data-v-a569c64a]{opacity:0}.overlay-enter-active[data-v-a569c64a],.overlay-leave-active[data-v-a569c64a]{transition:all .3s}", ""]);

// exports
